export const EXTERNAL_LINKS = {
  YNA_ABOUT: "https://welcome.yna.run/",
  YNA_DEV_UNLEASH_PROXY: "https://dev.yna.run/back/unleash-proxy",
  YNA_UNLEASH_PROXY: "https://yna.run/back/unleash-proxy",
  YNA_SUPPORT: "https://support.yna.run/main/",
  YNA_TERMS_OF_USE: "https://legal.yna.run/terms-of-use/",
  YNA_TERMS_PRIVACY_POLICY: "https://legal.yna.run/privacy-policy/",
  YNA_TERMS_OF_USE_RU: "https://legal.yna.run/terms-of-use-ru/",
  YNA_TERMS_PRIVACY_POLICY_RU: "https://legal.yna.run/privacy-policy-ru/",
  MAP_TILE_LAYER: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  YNA_TELEGRAM_SUPPORT: "https://t.me/yna_support",
  YNA_HOME: "https://yna.run/",
} as const;
